import React, { useCallback } from 'react';
import classNames from 'classnames';

import classes from './style.module.scss';

export type ListDefaultItem = { id: string | number, name: string }

export interface ListItemProps<T> {
  className?: string
  searchKey?: keyof T
  searchKeys?: Array<keyof T>
  item: T,
  renderItem?: (item: T, searchTerm?: string, matchedKeys?: Array<keyof T>) => React.ReactNode
  searchTerm?: string
  onSelect?: (item: T) => void
}

const ListItem = <T extends ListDefaultItem = ListDefaultItem>(
  { className, searchKey = 'name', searchKeys, item, renderItem, searchTerm, onSelect }: ListItemProps<T>
) => {
  const matchedKeys = searchTerm && searchKeys?.length
    ? searchKeys.filter(key => String(item[key] ?? '').toLowerCase().includes(searchTerm.toLowerCase()))
    : undefined;
  const itemClickHandler = useCallback(() => {
    if (onSelect) {
      onSelect(item);
    }
  }, [item, onSelect]);

  return (
    <div className={classNames(classes['list-item'], className)} onClick={itemClickHandler}>
      {renderItem ? renderItem(item, searchTerm, matchedKeys) : item[searchKey]}
    </div>
  );
};

export default ListItem
